<template>
    <b-modal v-model="show" title="ПАРАМЕТЕР" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>Номи <span class="red">*</span></label>
                        <input type="text"
                               class="form-control"
                               v-model="data.name"
                               :class="{invalid : $v.data.name.$error}"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" @click="save">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="cancel">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import initFilterModel from '@/shared/filter';
    import {clone} from '@/shared/utils';
    import {required} from 'vuelidate/lib/validators';

    export default {
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                filter: initFilterModel(),
                data: {
                    name: ''
                }
            }
        },
        validations: {
            data: {
                name: {
                    required: required
                }
            }
        },
        methods: {
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.processing = true;
                const vm = this;
                this.$http.post('central-street/save',this.data)
                    .then(res => {
                        vm.processing = false;
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$eventBus.$emit('showCentralStreetChanged', response);
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: response.message,
                                type: 'warning'
                            });
                        }
                    },err => {
                        vm.processing = false;
                        console.log(err);
                    });
            },
            cancel() {
                this.show = false;
            }
        },
        created() {
            this.filter.parentOnly = true;
            this.filter.page.size = 1000;
            this.$eventBus.$on('showCentralStreetAdd', (data) => {
                if (data) {
                    this.data = clone(data);
                }
                this.show = true;
            });
        }
    }
</script>

<style scoped>

</style>